var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaqs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 22C42 33.0458 33.0458 42 22 42C18.023 42 14.32 40.8402 11.2075 38.8371C10.9014 38.6401 10.5141 38.6118 10.1887 38.775L5.73662 41.0075C4.96713 41.3934 4.10209 40.6913 4.32134 39.8589L5.77764 34.3298C5.85482 34.0368 5.79373 33.7254 5.61952 33.4775C3.33847 30.2308 2 26.2745 2 22C2 10.9542 10.9542 2 22 2C33.0458 2 42 10.9542 42 22Z",
    stroke: "#0A7EF2",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9867 23.9137C19.9867 23.4406 19.9738 22.9675 19.991 22.4988C20.0255 21.4752 20.5934 20.7096 21.5529 20.3613C21.7466 20.2925 21.9445 20.2366 22.1338 20.1678C23.416 19.7033 24.1604 18.4001 23.9066 17.0798C23.6527 15.7638 22.4522 14.8004 21.1227 14.8477C19.763 14.8907 18.6787 15.8799 18.4937 17.2389C18.4679 17.4239 18.4421 17.6045 18.4033 17.7851C18.2613 18.4733 17.7579 18.8517 17.0824 18.7915C16.4671 18.7356 16.0282 18.241 16.0024 17.5787C15.9292 15.4713 17.5471 13.2392 19.5909 12.6371C23.1665 11.5834 26.4968 14.1424 26.3978 17.8711C26.3462 19.8581 24.9478 21.8063 23.0331 22.4472C22.5426 22.6106 22.4049 22.8342 22.435 23.3159C22.4737 23.9911 22.4608 24.6706 22.4393 25.3459C22.4135 26.1931 21.9058 26.7522 21.1958 26.7522C20.4816 26.7522 19.9953 26.1888 19.9781 25.3373C19.9695 24.8642 19.9781 24.3911 19.9781 23.9223C19.9824 23.9137 19.9824 23.9137 19.9867 23.9137Z",
    fill: "#0A7EF2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4362 30.389C22.4362 31.0384 21.8682 31.5975 21.2099 31.5975C20.5343 31.5975 19.9965 31.0599 19.9922 30.389C19.9922 29.7224 20.5429 29.1719 21.2056 29.1719C21.8596 29.1719 22.4362 29.7439 22.4362 30.389Z",
    fill: "#0A7EF2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqs);
export default __webpack_public_path__ + "static/media/faqs.ce40960211b17eab574550e414286721.svg";
export { ForwardRef as ReactComponent };